<template>
  <div>
    <PartnerHeader :img_header="header_image" header="รายการจัดการ POS" link_back="managepos"/>
    <MenuPartner/>
    <Report_information/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Report_information from "@/components/admin/manage_pos/partner_store_setting/Report_information";
export default {
  name: "ReportInformation",
  components: {
    Report_information,
    MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
